// extracted by mini-css-extract-plugin
export default {"menuItemLink":"styles_menuItemLink__+dIcv","activeItem":"styles_activeItem__9x+rQ"};